<template>
  <div class="statistics-container">
    <div class="cards-container">
      <div class="card-cell">
        <div class="title">
          <img src="../../../assets/Site/icon_2.png" class="icon" alt="" />
          总调度任务数
        </div>
        <div class="content">{{ spiderStat.spiderScheduleTotalNum }}</div>
      </div>
      <div class="card-cell">
        <div class="title">
          <img src="../../../assets/Site/icon_1.png" class="icon" alt="" />
          总结果数
        </div>
        <div class="content">{{ spiderStat.spiderRequestTotalNum }}</div>
      </div>
    </div>

    <div class="data-statistics-container">
      <div class="head">
        <div class="text">数据统计</div>
        <div class="time-select-tab" :class="{ active: timeDuration === 7 }" @click="ontimeDurationChange(7)">7日</div>
        <div class="time-select-tab" :class="{ active: timeDuration === 30 }" @click="ontimeDurationChange(30)">30日</div>
      </div>
      <div class="content">
        <div class="chart-container" ref="duaContainer"></div>
        <div class="number-container">
          <div class="row">
            <div class="circle-number">1</div>
            <div class="label">今日调度任务数</div>
            <div class="value">{{ currentSpiderStatDaily.spiderScheduleNum }}</div>
          </div>

          <div class="row">
            <div class="circle-number">2</div>
            <div class="label">今日解析率</div>
            <div class="value">{{ dailyAnalysis }}</div>
          </div>

          <div class="row">
            <div class="circle-number">3</div>
            <div class="label">今日新增结果数</div>
            <div class="value">{{ currentSpiderStatDaily.spiderRequestSuccNum }}</div>
          </div>

          <div class="row">
            <div class="circle-number">4</div>
            <div class="label">近{{ timeDuration }}日调度任务数</div>
            <div class="value">{{ spiderStat30.spiderScheduleTotalNum }}</div>
          </div>

          <div class="row">
            <div class="circle-number">5</div>
            <div class="label">近{{ timeDuration }}日新增结果数</div>
            <div class="value">{{ spiderStat30.spiderRequestTotalSuccNum }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="part-statistics-container">
      <div class="part">
        <div class="head">
          <div class="text">调度任务状态占比</div>
        </div>
        <div class="content" ref="dua2Container"></div>
      </div>

      <div class="part">
        <div class="head">
          <div class="text">新增趋势</div>
        </div>
        <div class="content" ref="pieContainer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatTotalBySpiderIdApi, getStat30BySpiderIdApi } from '@/api/Site/Info'
// import { DualAxes, Pie } from '@antv/g2plot'
export default {
  data() {
    return {
      spiderStat: {},
      spiderStat30: {},
      timeDuration: 30,

      dualAxesPlot: null,
      piePlot: null,
      dualAxesPlot2: null,

      pieData: []
    }
  },
  computed: {
    currentSpiderStatDaily() {
      return this.spiderStat30.currentSpiderStatDaily || {}
    },

    dailyAnalysis() {
      let n1 = this.currentSpiderStatDaily.spiderParseSuccNum
      let n2 = this.currentSpiderStatDaily.spiderParseNum
      return this._getPercent(n1, n2)
    }
  },
  mounted() {
    this.initChart()

    const { spiderId } = this.$route.query
    getStatTotalBySpiderIdApi({ spiderId }).then((res) => {
      if (res.code === 200) {
        this.spiderStat = res.extra.spiderStat
      }
    })

    this.getStatisticsDataByDay()
  },

  methods: {
    initChart() {
      this.dualAxesPlot = new DualAxes(this.$refs.duaContainer, {
        data: [[], []],
        xField: 'day',
        yField: ['todayNew', 'percent'],
        meta: {
          todayNew: {
            alias: '当日新增'
          },
          percent: {
            alias: '当日解析'
          }
        },
        geometryOptions: [
          {
            geometry: 'column'
          },
          {
            geometry: 'line',
            lineStyle: {
              lineWidth: 2
            }
          }
        ]
      })
      this.dualAxesPlot.render()

      this.piePlot = new Pie(this.$refs.pieContainer, {
        appendPadding: 10,
        data: [],
        angleField: 'value',
        colorField: 'type',
        color: ['#2D6AF6', '#FFAD42', '#6EB1ED', '#FF7646', '#49DCF4', ':#726EED', '#D76EED', '#4BD468'],
        radius: 0.8,
        innerRadius: 0.7,
        interactions: [{ type: 'element-active' }],
        state: {
          active: {
            style: (e) => {
              let shapeInfo = e.getModel()
              let option = {
                lineWidth: 0,
                shadowColor: `${shapeInfo.color}50`,
                shadowOffsetX: 2,
                shadowOffsetY: -4,
                shadowBlur: 30
              }
              return option
            }
          }
        },
        statistic: {
          title: {
            formatter: () => '任务量',
            style: {
              fontSize: '14px',
              color: '#999',
              marginTop: '-10px'
            }
          },
          content: {
            style: {
              color: '#333'
            },
            customHtml: (_, __, ___, data) => {
              return data.reduce((t, c) => t + c.value, 0).toString()
            }
          }
        },
        label: false,
        legend: {
          itemName: {
            spacing: 20
          },
          itemValue: {
            style: {
              fill: '#999'
            },
            formatter: (label) => {
              let number = this.pieData[label]
              let total = Object.keys(this.pieData).reduce((t, c) => t + this.pieData[c], 0)
              let percent = 100 * parseFloat(this._getPercent(number, total))
              let itemValue = `|   ${percent}%     ${number}`
              return itemValue
            }
          }
        }
      })
      this.piePlot.render()

      this.dualAxesPlot2 = new DualAxes(this.$refs.dua2Container, {
        data: [[], []],
        xField: 'day',
        yField: ['success', 'fail'],
        meta: {
          success: {
            alias: '成功结果数'
          },
          fail: {
            alias: '失败结果数'
          }
        },
        geometryOptions: [
          {
            geometry: 'line',
            lineStyle: {
              lineWidth: 2
            }
          },
          {
            geometry: 'line',
            lineStyle: {
              lineWidth: 2
            }
          }
        ]
      })

      this.dualAxesPlot2.render()
    },

    _getPercent(n1, n2) {
      if (n1 === undefined || n2 === undefined) {
        return 0
      }
      if (n1 === n2 && n1 === 0) {
        return 0
      }

      if (n2 === 0) {
        return 0
      }

      return (n1 / n2).toFixed(3)
    },

    getStatisticsDataByDay() {
      getStat30BySpiderIdApi({ spiderId: this.$route.query.spiderId, day: this.timeDuration }).then((res) => {
        if (res.code === 200) {
          this.spiderStat30 = res.extra.spiderStat
          this.drawDua()
          this.drawPie()
          this.drawDua2()
        }
      })
    },

    ontimeDurationChange(t) {
      if (this.timeDuration !== t) {
        this.timeDuration = t
        this.getStatisticsDataByDay()
      }
    },

    drawDua() {
      let spiderData = (this.spiderStat30.spiderStatDailys || []).map((d) => {
        let n1 = d.spiderParseSuccNum
        let n2 = d.spiderParseNum
        return {
          ...d,
          todayNew: d.spiderRequestSuccNum || 0,
          percent: parseFloat(this._getPercent(n1, n2)) * 100
        }
      })

      this.dualAxesPlot.changeData([spiderData, spiderData])
    },

    drawPie() {
      let percentMap = {
        成功: this.spiderStat30.spiderScheduleTotalSuccNum,
        执行: this.spiderStat30.spiderScheduleTotalDealNum,
        等待: this.spiderStat30.spiderScheduleTotalWaitNum,
        失败: this.spiderStat30.spiderScheduleTotalFailNum,
        未知: this.spiderStat30.spiderScheduleTotalUnKnownNum
      }
      this.pieData = percentMap

      const data = Object.entries(percentMap).map(([type, value]) => ({
        type,
        value
      }))

      this.piePlot.changeData(data)
    },

    drawDua2() {
      let spiderData = (this.spiderStat30.spiderStatDailys || []).map((d) => ({
        ...d,
        success: d.spiderRequestSuccNum || 0,
        fail: d.spiderRequestFailNum || 0
      }))

      this.dualAxesPlot2.changeData([spiderData, spiderData])
    }
  }
}
</script>


<style lang="less" scoped>
.statistics-container {
  width: 100%;

  .cards-container {
    width: 100%;
    display: flex;
    margin-bottom: 24px;

    .card-cell {
      width: calc(25% - 18px);
      height: 10vw;
      margin-right: 24px;
      background: white;
      box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.09);
      border-radius: 2px;
      border: 1px solid #e8e8e8;
      display: flex;
      flex-direction: column;
      padding: 24px;
      font-size: 16px;

      .title {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        color: rgba(0, 0, 0, 0.85);
        font-size: 16px;

        .icon {
          width: 24px;
          margin-right: 12px;
        }
      }

      .content {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        font-weight: 600;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .data-statistics-container {
    width: 100%;
    background: white;
    border-radius: 2px;
    margin-bottom: 24px;

    .head {
      height: 55px;
      border-bottom: 1px solid #e9e9e9;
      display: flex;
      align-items: center;
      padding: 0 16px;

      .text {
        font-size: 16px;
        font-weight: 600;
        margin-right: auto;
      }

      .time-select-tab {
        margin-right: 32px;
        cursor: pointer;

        &.active {
          color: #1890ff;
        }
      }
    }

    .content {
      width: 100%;
      height: 20vw;
      display: flex;
      padding: 16px;

      .chart-container {
        flex: 1;
        overflow: hidden;
      }

      .number-container {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow: auto;
        margin-left: 48px;

        .row {
          display: flex;
          align-items: center;
          padding-right: 20px;
          font-size: 16px;

          .circle-number {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #1890ff;
            color: white;
            line-height: 20px;
            text-align: center;
            margin-right: 20px;
          }

          .label {
            width: 150px;
          }

          .value {
            width: 30px;
          }
        }
      }
    }
  }

  .part-statistics-container {
    display: flex;
    overflow: hidden;

    .part {
      flex: 1;
      background: white;
      overflow: hidden;

      .head {
        height: 55px;
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        align-items: center;
        padding: 0 16px;

        .text {
          font-size: 16px;
          font-weight: 600;
          margin-right: auto;
        }

        .time-select-tab {
          margin-right: 32px;
          cursor: pointer;

          &.active {
            color: #1890ff;
          }
        }
      }

      .content {
        width: 100%;
        height: 20vw;
        overflow: hidden;
        padding: 16px;
      }

      &:first-child {
        margin-right: 24px;
      }
    }
  }

  .detail-part {
    width: 100%;

    .title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .detail-kv-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .kv-cell {
        line-height: 34px;
        width: 33%;
        word-break: break-all;
        overflow: hidden;

        .number {
          color: #1890ff;
          font-weight: 600;
          font-size: 18px;
        }
      }
    }

    .chart-container {
      width: 100%;
      height: 15vw;
      margin-top: 16px;
    }
  }
}
</style>
